import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#C9318E" }}>Problem</span>
            </h2>
            <p>
              Sometimes delicate situations present themselves, which may
              require a team of installers who can work according to the special
              needs of the agents. The element of customization is imperative
              for this portal to ensure all users can avail excellent services.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/RE4/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={848}
              height={635}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
